import { render } from "./EventScanner.vue?vue&type=template&id=a0047ae4&ts=true&lang=pug"
import script from "./EventScanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventScanner.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__